// extracted by mini-css-extract-plugin
export default {"tupacGrid":"fj-z","tupacHeader":"gj-z","tupacHeader2":"hj-z","tupacMenu":"ij-z","tupacMenu2":"jj-z","tupacMain":"kj-z","tupacMain2":"lj-z"};